// extracted by mini-css-extract-plugin
module.exports = {"container":"empty-message_container__3csqv","message":"empty-message_message__3IeM0","imageContainer":"empty-message_imageContainer__2Co7W","image":"empty-message_image__3y7k0"};